module.exports = __webpack_public_path__ + "static/in-the-garden_2008-9293168b880937b4af9d34180890c383.jpg";